import { useEffect, useState } from "react";

import EditionSlider from "../components/EditionSlider";
import Interface from "../components/Interface";
import Navbar from "../components/Navbar";
import SliderL from "../components/SliderL";
import SliderR from "../components/SliderR";
import ArticleGrid from "../components/ArticleGrid";
import Footer from "../components/Footer";
import Single from "../components/Single";
import Loader from "../components/Loader";

export default function Home() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate full page load (components + data)
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500); // adjust if needed

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <div>
      <Navbar />
      <Interface />
      <SliderL />
      <SliderR />
      <Single />
      <ArticleGrid />
      <EditionSlider />
      <Footer />
    </div>
  );
}
